export default [
    {
        name: 'main',
        path: '/',
        component: () => import('@/views/main.vue'),
        meta: {
            requireAuth: true
        },
        children: [
            {
                name: 'dashboard',
                path: '',
                component: () => import('@/views/DashboardHome.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                name: 'compras',
                path: 'compras',
                component: () => import('@/views/Purchases.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                name: 'vendas',
                path: 'vendas',
                component: () => import('@/views/sales.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                name: 'cadastro',
                path: 'cadastro',
                component: () => import('@/views/registers.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                name: 'poder-publico',
                path: 'poder-publico',
                component: () => import('@/views/public_laws.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                name: 'rh',
                path: 'rh',
                component: () => import('@/views/RH.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                name: 'estoque',
                path: 'estoque',
                component: () => import('@/views/warehouses.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                name: 'config',
                path: 'config',
                component: () => import('@/views/config.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                name: 'financeiro',
                path: 'financeiro',
                component: () => import('@/views/financial.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                name: 'logistica',
                path: 'logistica',
                component: () => import('@/views/checkpoints.vue'),
                meta: { requireAuth: true }
            },
            {
                name: 'entrada',
                path: 'entrada',
                component: () => import('@/views/entrada.vue'),
                meta: { requireAuth: true }
            },
            {
                name: 'perfil',
                path: 'perfil',
                component: () => import('@/views/profile.vue'),
                meta: { requireAuth: true }
            },
            {
                name: 'relatorios',
                path: 'relatorios',
                component: () => import('@/views/reports.vue'),
                meta: { requireAuth: true }
            }
        ]
    },
    {
        name: 'privacy-policy',
        path: '/privacy-policy',
        component: () => import('@/views/PrivacyPolicy.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        name: 'terms-of-use',
        path: '/terms-of-use',
        component: () => import('@/views/TermsOfUse.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        name: 'login',
        path: '/login',
        component: () => import('@/views/login.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        name: 'recovery-pw',
        path: '/recover_password/:token',
        component: () => import('@/views/RecoveryPassword.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        name: 'admin-login',
        path: '/admin',
        component: () => import('@/views/AdminLogin.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        name: 'admin-panel',
        path: '/admin/panel',
        component: () => import('@/views/AdminPanel.vue'),
        meta: {
            requireAuth: false,
            requireAdminAuth: true
        }
    },
    {
        name: 'admin-tenants',
        path: '/admin/tenants',
        component: () => import('@/views/AdminTenants.vue'),
        meta: {
            requireAdminAuth: true
        }
    },
    {
        name: 'admin-users',
        path: '/admin/users',
        component: () => import('@/views/AdminUsers.vue'),
        meta: {
            requireAdminAuth: true
        }
    },
    {
        name: 'admin-analytics',
        path: '/admin/analytics',
        component: () => import('@/views/AdminAnalyticsOverview.vue'),
        meta: {
            requireAdminAuth: true
        }
    },
    {
        name: 'admin-analytics-tenants',
        path: '/admin/analytics/tenants',
        component: () => import('@/views/AdminAnalyticsTenants.vue'),
        meta: {
            requireAdminAuth: true
        }
    },
    {
        name: 'admin-analytics-modules',
        path: '/admin/analytics/modules',
        component: () => import('@/views/AdminAnalyticsModules.vue'),
        meta: {
            requireAdminAuth: true
        }
    },
    {
        name: 'admin-analytics-reactivation',
        path: '/admin/analytics/reactivation',
        component: () => import('@/views/AdminAnalyticsReactivation.vue'),
        meta: {
            requireAdminAuth: true
        }
    },
    {
        name: 'admin-analytics-inventory',
        path: '/admin/analytics/inventory',
        component: () => import('@/views/AdminAnalyticsInventory.vue'),
        meta: {
            requireAdminAuth: true
        }
    },
];